// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__USO0z","row":"Node_row__2GHNH","label":"Node_label__2aGKb","footer":"Node_footer__mrjKm"};